import { McAction } from '../IMcAction';
import initialState, { IQcPlanFlagState } from '../modules/qc-plan/IQcPlanFlagState';
import { GET_QC_PLAN_FLAG } from '../modules/qc-plan/qc-plan.action.const';
import { getQcPlanFlagState } from '../modules/qc-plan/qc-plan.reducer.logic';

export function qcPlanFlagReducer(state: IQcPlanFlagState = initialState, action: McAction) {
    switch (action.type) {
        case GET_QC_PLAN_FLAG:
            return getQcPlanFlagState(state, action);

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/app-states/reducers/qc-plan-flag.reducer.ts